export default __webpack_public_path__ + "98d7dff25456d7e3b4f93b6346362ce3.png";